"use strict";

var $ = require("jquery");
var uuid = require("./uuidMIT");
var CHANGE_PASSWORD_WIDGET = require("../html/ConfirmPassword.html");

require("../style/general.scss");
require("../style/uim-widget.scss");
var common = require("./common");

function validateParams(params) {
    if (!params.configuration.environment) {
        throw new Error("No environment provided to uim widget");
    }

    if (common.API_ENVIRONMENTS[params.configuration.environment] === undefined) {
        //The STATIC environment is not included in the list as it should not be used by client systems.
        throw new Error("Unknown environment passed. Please choose dev, dev-1, qa, stg, uat, or prod");
    }

    if (!!params.configuration.success && (typeof params.configuration.success !== "function")) {
        throw new Error("Success callback must be a function");
    }

    if (!!params.configuration.error && (typeof params.configuration.error !== "function")) {
        throw new Error("Error callback must be a function");
    }
}

function UimConfirmPasswordWidget(params) {
    validateParams(params);

    this.successCallback = params.configuration.success || window.morningstar.uim.success;
    this.errorCallback = params.configuration.error || window.morningstar.uim.error;

    this.currentPasswordPlaceholder = params.configuration.currentPasswordPlaceholder;
    this.apigeeKey = params.configuration.apigeeKey;

    this.environment = params.configuration.environment;
    this.baseUrl = common.API_ENVIRONMENTS[this.environment];

    this.element = params.element;
}

UimConfirmPasswordWidget.prototype.init = function () {
    var self = this;
    this.clearErrorMessages();
    this.element.append(CHANGE_PASSWORD_WIDGET);

    var currentPasswordField = this.element.find("input#uim-uCurrentPassword-input");
    this.fields = {
        currentPassword: currentPasswordField
    };

    if (this.currentPasswordPlaceholder) {
        currentPasswordField[0].placeholder = this.currentPasswordPlaceholder;
    }
};

UimConfirmPasswordWidget.prototype.showErrorMessages = function (status) {
    var errString = "Unable to verify password.";

    if (status === 400) {
        errString = "The password you have provided is incorrect.";
        this.element.find("input#uim-uCurrentPassword-input").parent().addClass("error");
    } else if (status !== 401 && status !== 403) {
        // 401 : cookie not present
        // 403 : cookie is not valid
        this.element.find("input#uim-uCurrentPassword-input").parent().addClass("error");
    }

    return errString;
};

UimConfirmPasswordWidget.prototype.clearErrorMessages = function () {
    this.element.find("input#uim-uCurrentPassword-input").parent().removeClass("error");
};

UimConfirmPasswordWidget.prototype.submit = function (params) {
    var self = this;

    $.ajax({
        method: "POST",
        url: this.baseUrl + "/passwords/verification-tokens",
        xhrFields: {
            withCredentials: true
        },
        data: JSON.stringify({
            data: {
                type: "password-verification-token",
                attributes: {
                    password: params.currentPassword
                }
            }
        }),
        headers: {
            ApiKey: this.apigeeKey,
            "X-API-RequestId": uuid()
        },
        dataType: 'json',
        contentType: "application/json",
        success: function (data, status) {
            self.element.find("input#uim-uCurrentPassword-input").val('*****');
            self.clearErrorMessages();
            self.successCallback(data.data.id);
        },
        error: function (xhr, status, errorThrown) {
            var errStr = self.showErrorMessages(xhr.status);
            self.errorCallback(new Error(errStr), xhr.status);
        }
    });
};

module.exports = {
    createComponent: function (params) {
        var uimWidget = new UimConfirmPasswordWidget(params);
        uimWidget.init();

        return {
            setProperty: function () {},
            destroy: function () {
                params.element.children().remove();
            },
            submit: function () {
                uimWidget.submit({
                    currentPassword: uimWidget.fields.currentPassword.val()
                });
            }
        };
    }
};



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/confirm-password.js
// module id = 23
// module chunks = 0